<div>
  <span class="label-item">
    {{ label() }}
  </span>

  @for (contact of (contacts() | slice : 0 : (collapsed() ? minLength() : contacts().length)); track contact; let last = $last) {
    <span
      class="item"
      [class.selected]="selectedConnections() | includesBy : contact.address : 'name'"
      (click)="selectContact(contact, $event)"
      [appParticipantContextMenu]="contact"
      [appParticipantContextMenuTenantItems]="tenantItems()"
      [appParticipantContextMenuShowContactOptions]="true"
      >
      {{ contact | formatParticipant }}{{ last ? '' : ', ' }}
      @if (contact?.vip) {
        <mat-icon
          class="item-vip"
          svgIcon="crown"
          />
      }
    </span>
  }

  @if (collapsed() && contacts()?.length > minLength()) {
    <span
      class="link"
      (click)="toggleContacts()"
      >
      + {{ contacts().length - minLength() }} more
    </span>
  }

  @if (!collapsed()) {
    <span
      class="link"
      (click)="toggleContacts()"
      >
      Show less
    </span>
  }
</div>
